import { Injectable } from '@angular/core';
import constantURL from '../../../../../../../shared/constantURL';
import {HttpClient,HttpHeaders} from '@angular/common/http';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class requestShopifyScript{
  constructor(private http: HttpClient, private router :Router) {}
   _path:string = constantURL.settings.profile.businessInfo.requestShopifyScript;
   headers:HttpHeaders ;
   async make(){
    this.headers = new HttpHeaders({
      'x-url': this.router.url.split('?')[0],
    });
   return await this.http.get(this._path,{headers:this.headers , responseType:"text"}).toPromise();
   }
}
